package nl.volleyplanner.api.planner

import kotlinx.serialization.Serializable
import nl.volleyplanner.api.types.BigNumber


@Serializable
data class HardMediumSoftScore(
    val hardScore: BigNumber,
    val mediumScore: BigNumber,
    val softScore: BigNumber
) : Comparable<HardMediumSoftScore> {
    companion object {
        val ZERO = HardMediumSoftScore(BigNumber(0.0, 0), BigNumber(0.0, 0), BigNumber(0.0, 0))
    }

    operator fun plus(score: HardMediumSoftScore) =
        HardMediumSoftScore(this.hardScore + score.hardScore, this.mediumScore + score.mediumScore, this.softScore + score.softScore)

    operator fun minus(score: HardMediumSoftScore) =
        HardMediumSoftScore(this.hardScore - score.hardScore, this.mediumScore - score.mediumScore, this.softScore - score.softScore)

    override fun compareTo(other: HardMediumSoftScore): Int =
        compareValuesBy(this, other, { it.hardScore }, { it.mediumScore }, { it.softScore })
}

/**
 * All supported constraints by the planner
 * Should remain in sync with the same enum in the backend
 */
enum class PlannerTaskAssignmentConstraint {
    IsUnassigned,
    ImpossibleAssignment,
    IsUnavailable,
    HasNoMatch,
    HasNoMatchPerson,
    NoTaskForOwnMatch,
    NoTaskDuringOwnMatch,
    NotEligibleForThisTask,
    OneTaskPerWeek,
    VolunteerExemption,
    TaskStartTimeTooLateForAgeGroup,
    TooLongWaitingTime,
    MinimizeWaitingTime,
    MinimizePersonTotalWaitingTime,
    NotPreferredForThisTask,
    EvenlySpreadOverPersons,
    MatchProportionalTaskLoad,
    PrioritizeByFairness,
    EvenlySpreadOverTeamsPerDay,
    TryAssignTeamOnSameDay,
    AssignTeamMembersAtSameTime,
    DeprioritizeRefereeAsScoreKeeper,
    PrioritizeRefereeGroupAgeGroup,
    PrioritizeRefereeGroup,
    RewardHigherExpectedTasks;

    companion object {}
}

enum class RuleSolvabilityType {
    Unsolvable,
    RuleChange,
    ConfigurationChange
}

enum class TaskAssignmentConstraintRuleType {
    Helper,
    PersonImpact,
    PlanningImpact,
}

@Serializable
data class TaskAssignmentConstraint(
    val constraintName: PlannerTaskAssignmentConstraint,
    val technicalConstraintName: String,
    val taskAssignmentConstraintRuleType: TaskAssignmentConstraintRuleType
)

@Serializable
data class ConstraintScoreImpact(
    val constraint: TaskAssignmentConstraint,
    val impact: HardMediumSoftScore,
    val humanReadableImpact: String?
)